import React from "react";
import "./Header.css";

export function HeaderTitle() {
  return (
    <div className="header-container">
      <div className="header-title">🔧 RenderX Plugins Demo</div>
    </div>
  );
}

